export default __webpack_public_path__ + "img/bg_festival-f3b39df30102d1409a46114cc1895f0b.png";